module.exports = __webpack_public_path__ + "img/end-header-background-in.1e91a01f.png";